import type { CustomProduct, ProductGroup } from '@apptus/esales-api';

import type { MarketConfiguration } from '@/config/markets/const';

import { elevateProductToNgProduct } from './mapElevateProducts';

function sortProductsByPrice(products: CustomProduct[]) {
    return products.sort(
        (productA, productB) =>
            productA.sellingPrice.min - productB.sellingPrice.min,
    );
}
function getInStockProducts(products: CustomProduct[]) {
    const selection = products.filter(
        (product) => product.typedCustom?.numbers.stockOnHand,
    );
    if (!selection.length) return products;
    return selection;
}

export default function mapElevateProductGroups(
    productGroups: ProductGroup[],
    marketConfig: MarketConfiguration,
) {
    return productGroups.map((productGroup) => {
        // get the lowest priced product
        const products = productGroup.products as CustomProduct[];
        const inStockProducts = getInStockProducts(products);
        const [lowestPriceProduct] = sortProductsByPrice(inStockProducts);
        const fromPrice = products.some(
            (p) => p.sellingPrice.min !== lowestPriceProduct?.sellingPrice.min,
        );
        return elevateProductToNgProduct(
            lowestPriceProduct,
            { hasVariants: productGroup.products.length > 1 },
            marketConfig,
            fromPrice,
        );
    });
}
